import styled from 'styled-components';

import { COLORS } from '@r1-frontend/ui-react/tokens/colors';
import { FONTS } from '@r1-frontend/ui-react/tokens/fonts';

export const STitle = styled.div<{ isPromo: boolean }>`
    ${({ isPromo }) => isPromo ? FONTS.H5 : FONTS.MediumS};
    color: ${COLORS.TextPrimary};
    transition: color .25s;
`;
